var minWindowWidth = 880;

jQuery(document).ready(function($) {

  $('.lazy').lazyload({
    effect: 'fadeIn',
    threshold: 100
  });

  $('#menu-toggle, #mobile-close').click(function() {
    $('body').toggleClass('menu-expanded');
  });

  $('.dandy-daily-social-toggle').click(function(e) {
    e.preventDefault();
    $('.dandy-daily-social').toggleClass('active');
  });

  $('.daily-categories-expand').click(function() {
    $('.daily-categories-list.secondary-list').toggleClass('active');
  });

  if ($(window).width() >= minWindowWidth && $('body').hasClass('single-post')) {
    var waypoint = new Waypoint({
      element: $('.post .post-utility'),
      handler: function(direction) {
        $('#up-next').fadeToggle();
      },
      offset: 'bottom-in-view'
    });
  }

});
